import React, { useState } from "react";
import api from "../../api/axios";

const DealerEditModal = ({ dealer, onClose, onSaved }) => {
  const [form, setForm] = useState(dealer);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleUpdate = async () => {
    await api.put(`companyblog/admin/dealers/${dealer.id}/`, form);
    onSaved();
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h4>Edit Dealer</h4>

        <div className="row">
          <div className="col">
            <label>Dealer Name</label>
            <input
              className="form-control"
              name="dealers_name"
              value={form.dealers_name}
              onChange={handleChange}
            />
          </div>
          <div className="col">
            <label>Email</label>
            <input
              className="form-control"
              name="email"
              value={form.email || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col">
            <label>Phone</label>
            <input
              className="form-control"
              name="phone_no"
              value={form.phone_no || ""}
              onChange={handleChange}
            />
          </div>
          <div className="col">
            <label>Dealer Address</label>
            <input
              className="form-control"
              name="dealers_address"
              value={form.dealers_address || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="mt-4">
          <button className="btn btn-primary me-2" onClick={handleUpdate}>
            Update
          </button>
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default DealerEditModal;
